import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  getChannels: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/channels" + params);
  },
  getChannel: function(id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/channels/" + id + params);
  },
  // get already selected users and groups in a playlist
  getSelectedUserGroups: function(id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-selected-user-groups/" + id + params);
  },
  getChannelUsersWithState: function(channelId, params) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/channel/users/all/" + channelId + params
    );
  },
  getChannelGroupsWithState: function(channelId, params) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/channel/groups/" + channelId + params
    );
  },
  createChannel: function(channel, s3 = '', file = '') {
    return axios.post(IMPROVE_CONFIG.API_URL + "/channels", {
      name: channel.name,
      description: channel.description,
      icon: channel.icon,
      s3_url: s3,
      file: file,
      thumbnail: channel.thumbnail
    });
  },
  addCourseToChannel: function(channelCourse) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/channel/course", {
      course: channelCourse.course,
      channel: channelCourse.channel,
      level: channelCourse.level
    });
  },
  saveKanban: function(id, blocks, stages) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/channel/kanban/" + id, {
      blocks: blocks,
      stages: stages
    });
  },
  saveModules: function(id, modules) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/channel/modules/" + id, {
      modules: modules.modules
    });
  },
  saveCourseOrder: function(id, tree) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/channel/course-order", {
      channel: id,
      tree: tree
    });
  },
  updateChannel: function(id, channel, s3 = '', file = '') {
    return axios.patch(IMPROVE_CONFIG.API_URL + "/channels/" + id, {
      name: channel.name,
      description: channel.description,
      icon: channel.icon,
      s3_url: s3,
      file: file,
      thumbnail: channel.thumbnailOption
    });
  },


  assignUsers: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/channel/assign/" + id, {
      assign_users: data.assign_users,
      unassign_users: data.unassign_users,
      assign_groups: data.assign_groups,
      unassign_groups: data.unassign_groups
    });
  },
  addChannelAsset: function(id, s3Url, file, asset) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/channel/asset", {
      channel_id: id,
      s3_url: s3Url,
      file: file,
      title:asset.title
    });
  },
  removeChannelAsset: function(id) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/channel/asset/" + id);
  },
  removeChannel: function(id) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/channels/" + id);
  },
  getChannelEnrolledUsers: function(channelId, params, search) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/channel/enrolled-users/" + channelId + params + search
    );
  },
  getChannelUnenrolledUsers: function(channelId, params, search) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/channel/unenrolled-users/" + channelId + params + search
    );
  },
  getChannelsReport: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/channels-report" + params);
  },
  getChannelUser: function(id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/channels-user/" + id + params);
  },
  getChannelEnrolledGroupsWithState: function(channelId, params, searchParams) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/channel/enrolled-groups/" + channelId + params + searchParams
    );
  },
  getChannelUnenrolledGroupsWithState: function (channelId, params, searchParams) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/channel/unenrolled-groups/" + channelId + params + searchParams
    );
  },
  enrolStaffChannel: function(data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/enrol/users-to-channel", {
      users: data.assign_users,
      assign_playlists: data.assign_playlists
    });
  },
  getUnEnrolPlaylists: function(params, id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/unenrolled-user-playlists" + params + "&id=" + id);
  },
  getEnrolPlaylists: function(params, id) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/enrolled-user-playlists" + params + "&id=" + id);
  },
  enrolPlaylists: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/enrol/playlists/" + id, {
      assign_playlists: data.assign_playlists,
      unassign_playlists: data.unassign_playlists
    });
  },
  getDetailedReport: function (id,params){
     return axios.get(IMPROVE_CONFIG.API_URL + "/channel_detailed_report" + params + "&id=" + id);
  },
  exportDetailedReportCSV: function(id, type) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/channel-detailed-reprot-export/" + id +'/' + type
    );
  },
};
